import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const StablePatientIcon: React.FC<IconProps> = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 2.0647C10.0413 2.0647 8.64236 2.64416 7.61091 3.67561C6.57946 4.70706 6 6.10601 6 7.5647C6 9.02339 6.57946 10.4223 7.61091 11.4538C8.64236 12.4852 10.0413 13.0647 11.5 13.0647C12.9587 13.0647 14.3576 12.4852 15.3891 11.4538C16.4205 10.4223 17 9.02339 17 7.5647C17 6.10601 16.4205 4.70706 15.3891 3.67561C14.3576 2.64416 12.9587 2.0647 11.5 2.0647ZM23.657 15.1547L16.585 22.2257L12.343 17.9827L13.757 16.5687L16.585 19.3977L22.242 13.7407L23.657 15.1547Z" fill="#A0AEC0"/>
<path d="M12.876 14.0647C11.9821 15.2062 11.4975 16.6149 11.5 18.0647C11.5 19.5737 12.014 20.9617 12.876 22.0647H2V20.0647C2 18.4734 2.63214 16.9473 3.75736 15.8221C4.88258 14.6968 6.4087 14.0647 8 14.0647H12.876Z" fill="#A0AEC0"/>
</svg>


);

export default StablePatientIcon;


